import { receiveMessageOnPort } from "worker_threads";

export class SseStream{
    source: EventSource|null;
    constructor(){
        this.source = null;
    }

        connect(url:string){
            if(!this.source)
            this.source = new EventSource(url);
        }

        disconnect(){
            if(this.source){
                this.source.close();
            }
        }
        on(eventName:string, callback: (this: EventSource, event: MessageEvent<any>) => any){
            if(this.source){
                this.source.addEventListener(eventName, callback);
            }
        }
}